import $ from "jquery";
import './js/cvsimport';

jQuery(function () {
  console.log("Ready release/1.1");

  const BASEURL = $("#base-url").data("url");

  // Header related /////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".nav-mobile--toggle").on("click", function () {
    console.log("Clicked");
    const isActive = $(this).hasClass("active");

    console.log("isActive", isActive);

    if (isActive) {
      $(this).removeClass("active");
      $(this).text("MENU");
      $("body").css("overflow-y", "unset");
      $(".nav-mobile--tray").fadeOut();
    } else {
      $(this).addClass("active");
      $(this).text("CLOSE");
      $("body, html").scrollTop(0);
      $("body").css("overflow-y", "hidden");
      $(".nav-mobile--tray").fadeIn();
    }
  });
  // Header related /////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Home - keyword input field /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $("#home-keyword").on("keyup", function (e) {
    console.log("e.key", e.key);
    console.log("e.target.value", e.target.value);

    if (e.key === "Enter") {
      window.location =
        BASEURL + "library?keyword=" + encodeURIComponent(e.target.value);
    }
  });
  // Home - keyword input field /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Contact - form submission //////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $("#form-contact").on("submit", function (e) {
    e.preventDefault();
    $(".tema-form-error").remove();

    const textFields = ["name", "email", "subject", "message"];
    let error = false;

    $.each(textFields, (i, v) => {
      const fieldValue = $("#" + v).val();
      const isNotValid = /^\s*$/.test(fieldValue);

      if (isNotValid) {
        $("#" + v)
          .parent()
          .append(
            '<div class="tema-form-error ' +
              v +
              ' text-sm text-red-700 italic mt-1">This field is required.</div>'
          );
        error = true;
      }
    });

    if ($(".tema-form-error.email").length <= 0) {
      const email = $("#email").val();
      const isValidEmail = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(email);

      if (!isValidEmail) {
        $("#email")
          .parent()
          .append(
            '<div class="tema-form-error email text-sm text-red-700 italic mt-1">Invalid email address.</div>'
          );
        error = true;
      }
    }

    if (error) {
      return;
    }

    $("#contact-form-wrapper").append('<div class="tema-form-blocker"></div>');

    // return;

    let csrfToken;

    $('.contact-form-message').hide();

    $.ajax({
      url: BASEURL + "session/token",
      type: "GET",
      success: function (response) {
        csrfToken = response;

        const values = {
          name: $("#name").val(),
          email: $("#email").val(),
          subject: $("#subject").val(),
          message: $("#message").val(),
        };

        $.ajax({
          url: BASEURL + "api/form/contactfeedback/submit",
          type: "POST",
          data: JSON.stringify(values),
          contentType: "application/json",
          headers: {
            "X-CSRF-Token": csrfToken,
          },
          success: function (res) {
            // Handle success response
            console.log("Form submitted successfully!");

            $("#form-contact").addClass("invisible");
            $(".tema-form-blocker").remove();
            $("#contact-form-thank-you").fadeIn();
          },
          error: function (xhr, status, error) {
            // Handle error response
            $('.contact-form-message').text(xhr.responseJSON.errors);
            $('.contact-form-message').show();
            $(".tema-form-blocker").remove();
          },
        });
      },
      error: function (xhr, status, error) {
        console.error("Error fetching CSRF token:", error);
      },
    });
  });
  // Contact - form submission //////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('a[href*="#"]:not([href="#"]):not(.sf-dump-toggle)').on(
    "click",
    function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          );

          target.trigger("focus");
          return false;
        }
      }
    }
  );
  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
